var scope_0 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/11fd3f66b6e3e6a77be44f9aa91de842.js').default;
var scope_1 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4387b842e5f812f1afae8e8cc1e078e5.js').default;
var scope_2 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/77a8842d689d121992cf317e80bb1dc4.js').default;
var scope_3 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/959970bc90eac4e322842c9fa07bb635.js').default;
var scope_4 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;
var scope_5 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d4bc0ca9d6863084883d2b07a20816e9.js').default;
var scope_6 = require('/opt/build/repo/packages/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d7699415e6cf327de572bd2bd6a069dc.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6 )
    